import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { askRedo } from "./schema/ask-redo";
import {
  createBillingSetupIntent,
  getBillingStatus,
  saveBillingPaymentMethod,
} from "./schema/billing";
import { connectChargebacksStripe } from "./schema/chargebacks/connect-chargebacks-stripe";
import { exchangeShopifyOAuthCode } from "./schema/chargebacks/exchange-shopify-oauth-code";
import { getChargebacksGorgiasAuthUrl } from "./schema/chargebacks/get-chargebacks-gorgias-auth-url";
import { getChargebacksInsights } from "./schema/chargebacks/get-chargebacks-insights";
import { getChargebacksPaypalAuthUrl } from "./schema/chargebacks/get-chargebacks-paypal-auth-url";
import { getChargebacksProviderStatus } from "./schema/chargebacks/get-chargebacks-provider-status";
import { getChargebacksScopeStatus } from "./schema/chargebacks/get-chargebacks-scope-status";
import { completeOnboarding } from "./schema/complete-onboarding";
import { getAppEmbedStatus } from "./schema/get-app-embed-status";
import { getProgress } from "./schema/get-progress";
import { getResumeState } from "./schema/get-resume-state";
import { initialize } from "./schema/initialize";
import { listResumeStates } from "./schema/list-resume-states";
import { activateRecoverIntent } from "./schema/recover/activate-recover-intent";
import { enableRecoverBilling } from "./schema/recover/enable-recover-billing";
import { getRecoverRevenueEstimate } from "./schema/recover/get-recover-revenue-estimate";
import { provisionRecoverPhoneNumber } from "./schema/recover/provision-recover-phone-number";
import { saveTeamProfileFields } from "./schema/recover/save-team-profile-fields";
import { aiReturnReasons } from "./schema/returns/ai-return-reasons";
import { analyzePolicy } from "./schema/returns/analyze-policy";
import { archiveReturnsOnboarding } from "./schema/returns/archive-returns-onboarding";
import { getCoverageBuilderContext } from "./schema/returns/get-coverage-builder-context";
import { getExclusionOptions } from "./schema/returns/get-exclusion-options";
import { getGoogleMapsKey } from "./schema/returns/get-google-maps-key";
import { getStoreProducts } from "./schema/returns/get-store-products";
import { saveReturnsCoverageBuilder } from "./schema/returns/save-coverage-builder";
import { saveProgress } from "./schema/save-progress";

export const rpcDefinition = {
  activateRecoverIntent,
  archiveReturnsOnboarding,
  askRedo,
  connectChargebacksStripe,
  enableRecoverBilling,
  exchangeShopifyOAuthCode,
  getRecoverRevenueEstimate,
  provisionRecoverPhoneNumber,
  saveTeamProfileFields,
  getChargebacksGorgiasAuthUrl,
  getChargebacksInsights,
  getChargebacksPaypalAuthUrl,
  getChargebacksProviderStatus,
  getChargebacksScopeStatus,
  aiReturnReasons,
  analyzePolicy,
  createBillingSetupIntent,
  completeOnboarding,
  getAppEmbedStatus,
  getBillingStatus,
  getCoverageBuilderContext,
  getExclusionOptions,
  getGoogleMapsKey,
  getProgress,
  getResumeState,
  getStoreProducts,
  initialize,
  listResumeStates,
  saveBillingPaymentMethod,
  saveProgress,
  saveReturnsCoverageBuilder,
};

export type RedoOnboardingV2RpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
